import { render, staticRenderFns } from "./EventSummary.vue?vue&type=template&id=6521c6e6"
import script from "./EventSummary.vue?vue&type=script&lang=js"
export * from "./EventSummary.vue?vue&type=script&lang=js"
import style0 from "./EventSummary.vue?vue&type=style&index=0&id=6521c6e6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6521c6e6')) {
      api.createRecord('6521c6e6', component.options)
    } else {
      api.reload('6521c6e6', component.options)
    }
    module.hot.accept("./EventSummary.vue?vue&type=template&id=6521c6e6", function () {
      api.rerender('6521c6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EventSummary.vue"
export default component.exports